export default "__VITE_ASSET__3084f33b__"